import React, { useCallback } from "react";
import { useHomeData } from "../../../contexts/HomeDataContext";
import { IReferralData, ProgressState } from "../../../interfaces/home";
import ReferralEarningsShimmer from "./ReferralEarningsShimmer";
import { ErrorComponent } from "../../errorComponent";
import ReferralEarningsSuccessView from "./ReferralEarningsSuccessView";
import { isValidData } from "utils/object";

const ReferralEarnings = () => {
    const { userData, retryUserData } = useHomeData();
    const { state, data } = userData;

    const getStateToRender = useCallback(() => {
        switch (state) {
            case ProgressState.IN_PROGRESS:
                return <ReferralEarningsShimmer />;
            case ProgressState.COMPLETED:
                if (!isValidData(data?.referral_data)) {
                    return null;
                }
                return <ReferralEarningsSuccessView earningsData={data?.referral_data as IReferralData} />;
            case ProgressState.FAILED:
                return <ErrorComponent onRetry={retryUserData} />;
            default:
                return null;
        }
    }, [state, data, retryUserData]);

    return getStateToRender();
};

export default ReferralEarnings;
